import { IUserModel } from "../types/types";

/**
 * Utility function to check if a user has an active subscription
 * This includes admins, pro users, and users with active/trialing subscriptions
 */
export const hasActiveSubscription = (
  user: IUserModel | null | undefined
): boolean => {
  if (!user) {
    return false;
  }

  return (
    user.isAdmin === true ||
    user.subscriptionStatus === "active" ||
    user.subscriptionStatus === "trialing"
  );
};

/**
 * Utility function to check if a user is a premium user (Pro or Admin)
 */
export const isPremiumUser = (user: IUserModel | null | undefined): boolean => {
  if (!user) {
    return false;
  }

  return user.isAdmin === true || user.isPro === true;
};

/**
 * Utility function to check if a user has a paid subscription (not admin/pro override)
 */
export const hasPaidSubscription = (
  user: IUserModel | null | undefined
): boolean => {
  if (!user) {
    return false;
  }

  return (
    user.subscriptionStatus === "active" ||
    user.subscriptionStatus === "trialing"
  );
};
